import './bullseye.css';
export default {
  "bullseye": "pf-v5-l-bullseye"
};